import css from 'styled-jsx/css';

const staticStyles = css.global`
  .BOPaginationTable {
    &__pagination {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;

      span {
        color: rgba(51, 51, 51, 0.25);
        font-size: 14px;
      }

      &__nav {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 32px;

        &-buttons {
          display: flex;
          gap: 8px;
        }

        &-btn {
          width: 40px;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #e5e5e5;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child,
          &:last-child {
            svg {
              position: relative;

              &:first-child {
                left: 2px;
              }

              &:last-child {
                right: 2px;
              }
            }
          }

          svg {
            color: #333;
            transform: rotate(90deg);
          }

          &--next {
            svg {
              transform: rotate(-90deg);
            }
          }

          &:disabled {
            opacity: 0.25;
          }
        }

        &-input {
          width: 64px;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #e5e5e5;
          background: #fff;
          color: #333;
          font-size: 14px;
          padding: 0;
          padding-left: 12px;

          &:disabled {
            opacity: 0.25;
          }

          &-wrapper {
            display: flex;
            gap: 16px;
            align-items: center;
          }
        }
      }

      &__info {
        display: flex;
        align-items: center;
        gap: 32px;
      }

      &__select-wrapper {
        width: 120px;

        :global(.BaseSelectField) {
          background-color: #fff;
          margin: 0;
        }

        :global(.Select__control) {
          border-color: #e5e5e5;
          border-radius: 4px;
          padding: 10px 0 !important;
          padding-left: 16px !important;
          padding-right: 50px !important;
          min-height: fit-content !important;

          &::after {
            width: 8px;
            height: 8px;
            border-color: #e5e5e5 !important;
            top: 35%;
          }
        }

        :global(.Select__single-value) {
          color: #333;
          font-size: 14px;
          overflow: visible;
        }

        :global(.Select__value-container) {
          overflow: visible;
        }
      }

      &__current-page-info {
        display: flex;
        align-items: center;
        gap: 8px;

        &--bold {
          font-weight: 700;
          color: #333 !important;
        }
      }
    }
  }
`;

export { staticStyles };
